/**
 * Menvora — COD funnel (Releasit) v3.8
 * Transport: MenvoraAnalytics (envelope + cod_session_id).
 * Field complete: focusout/blur. Page dwell: window load → pagehide.
 * v3.7: CodFormAbandon (empezó Field y salió sin SubmitAllowed).
 * v3.8: deja de emitir CodFormSuccessHint (era page-hide mal nombrado, no post-éxito).
 */
(function () {
  if (window.__menvoraCodFunnelV38) return;
  window.__menvoraCodFunnelV38 = true;

  function track(name, params, options) {
    var opts = options || {};
    if (name === 'PageDwell' || name === 'CodFormAbandon') {
      opts.transport_type = opts.transport_type || 'beacon';
    }
    if (window.MenvoraAnalytics && typeof window.MenvoraAnalytics.track === 'function') {
      window.MenvoraAnalytics.track(name, params, opts);
      return;
    }
    var payload = params || {};
    try {
      if (typeof window.fbq === 'function') window.fbq('trackCustom', name, payload);
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e2) {}
  }

  function sanitize(v) {
    if (window.MenvoraAnalytics && typeof window.MenvoraAnalytics.sanitize === 'function') {
      return window.MenvoraAnalytics.sanitize(v);
    }
    return String(v || 'unknown')
      .replace(/[^a-zA-Z0-9_.\- ]/g, '_')
      .slice(0, 80);
  }

  function newSessionId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID().replace(/-/g, '').slice(0, 16);
      }
    } catch (e) {}
    return 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  function syncCodSession() {
    if (window.MenvoraAnalytics && typeof window.MenvoraAnalytics.setCodSession === 'function') {
      window.MenvoraAnalytics.setCodSession({
        id: state.sessionId,
        had_error: state.hadError ? 1 : 0,
        submit_allowed: state.submitAllowed ? 1 : 0,
        fields_touched: Object.keys(state.seenFields).length,
      });
    } else {
      window.__menvoraCodSession = {
        id: state.sessionId,
        had_error: state.hadError ? 1 : 0,
        submit_allowed: state.submitAllowed ? 1 : 0,
      };
    }
  }

  function noteError(errorType, field) {
    state.hadError = true;
    state.lastErrorType = sanitize(errorType || 'unknown');
    state.lastErrorField = sanitize(field || state.lastField || 'unknown');
    syncCodSession();
  }

  var state = {
    open: false,
    bound: false,
    lastField: null,
    seenFields: {},
    blurredFields: {},
    openedAt: 0,
    poll: null,
    sessionId: null,
    hadError: false,
    lastErrorType: null,
    lastErrorField: null,
    submitAllowed: false,
    abandonSent: false,
    startedFilling: false,
  };

  function dialogEl() {
    return document.getElementById('rsi_form_wrapper');
  }

  function formEl() {
    var d = dialogEl();
    if (!d) return null;
    return d.querySelector('form._rsi_main_form_element') || d.querySelector('form');
  }

  function isOpen() {
    var d = dialogEl();
    if (!d) return false;
    if (d.hasAttribute('open')) return true;
    if (typeof d.open === 'boolean' && d.open) return true;
    var f = formEl();
    return !!(f && f.getAttribute('data-open') === 'true');
  }

  function fieldKey(el) {
    if (!el) return 'unknown';
    return el.getAttribute('name') || el.id || el.getAttribute('placeholder') || el.tagName.toLowerCase();
  }

  function setCodChrome(open) {
    try {
      document.body.classList.toggle('menvora-cod-form-open', !!open);
      window.dispatchEvent(
        new CustomEvent('menvora:cod-form-chrome', { detail: { open: !!open } })
      );
    } catch (e) {}
  }

  function markOpen(reason) {
    if (state.open) return;
    state.open = true;
    state.openedAt = Date.now();
    state.lastField = null;
    state.seenFields = {};
    state.blurredFields = {};
    state.sessionId = newSessionId();
    state.hadError = false;
    state.lastErrorType = null;
    state.lastErrorField = null;
    state.submitAllowed = false;
    state.abandonSent = false;
    state.startedFilling = false;
    syncCodSession();
    setCodChrome(true);
    track('CodFormOpen', {
      reason: sanitize(reason),
      cod_session_id: sanitize(state.sessionId),
    });
    var f = formEl();
    if (f) {
      track('CodFormStep', {
        step: sanitize(f.getAttribute('data-page') || 'fields'),
        cod_session_id: sanitize(state.sessionId),
      });
    }
  }

  function emitAbandon(abandonReason) {
    if (state.abandonSent) return;
    if (!state.startedFilling) return;
    if (state.submitAllowed) return;
    state.abandonSent = true;
    var reason = abandonReason || 'user_close';
    if (state.hadError && reason === 'user_close') reason = 'error_friction';
    track(
      'CodFormAbandon',
      {
        abandon_reason: sanitize(reason),
        had_error: state.hadError ? 1 : 0,
        last_error_type: sanitize(state.lastErrorType || ''),
        last_error_field: sanitize(state.lastErrorField || ''),
        fields_touched: Object.keys(state.seenFields).length,
        last_field: sanitize(state.lastField),
        dwell_ms: state.openedAt ? Date.now() - state.openedAt : 0,
        cod_session_id: sanitize(state.sessionId || ''),
      },
      { transport_type: 'beacon' }
    );
  }

  function markClose(closeReason) {
    if (!state.open) return;
    emitAbandon(closeReason || 'user_close');
    state.open = false;
    setCodChrome(false);
    track('CodFormClose', {
      last_field: sanitize(state.lastField),
      dwell_ms: Date.now() - state.openedAt,
      fields_completed: Object.keys(state.blurredFields).length,
      cod_session_id: sanitize(state.sessionId || ''),
      had_error: state.hadError ? 1 : 0,
    });
  }

  function inCod(el) {
    return !!(el && el.closest && el.closest('#rsi_form_wrapper, form._rsi_main_form_element'));
  }

  function isReleasitBuyCta(el) {
    if (!el || !el.closest) return false;
    return !!el.closest('#rsi_buy_now_button, .rsi_floating_bottom, [data-rsi-cod-button="true"]');
  }

  function isCodCtaLabel(text) {
    return /pago contra entrega|pagar contra entrega|pedir ahora|pagar al recibir|pedir contra entrega|pago al recibir/i.test(text);
  }

  function bind() {
    if (state.bound) return;
    state.bound = true;

    document.addEventListener(
      'focusin',
      function (ev) {
        var el = ev.target;
        if (!inCod(el)) return;
        if (!/^(INPUT|SELECT|TEXTAREA)$/.test(el.tagName)) return;
        markOpen('focusin');
        var key = sanitize(fieldKey(el));
        state.lastField = key;
        state.startedFilling = true;
        syncCodSession();
        if (!state.seenFields[key]) {
          state.seenFields[key] = 1;
          track('CodFormField', {
            field: key,
            action: 'first_focus',
            cod_session_id: sanitize(state.sessionId || ''),
          });
        }
      },
      true
    );

    // blur via focusout (bubbles); registra 'blur' (con valor) y 'blur_empty' (sin valor, señal de drop-off)
    document.addEventListener(
      'focusout',
      function (ev) {
        var el = ev.target;
        if (!inCod(el)) return;
        if (!/^(INPUT|SELECT|TEXTAREA)$/.test(el.tagName)) return;
        markOpen('blur');
        var key = sanitize(fieldKey(el));
        state.lastField = key;
        state.startedFilling = true;
        syncCodSession();
        var hasValue = el.type === 'checkbox' || el.type === 'radio' ? !!el.checked : String(el.value || '').trim().length > 0;
        if (hasValue) {
          if (state.blurredFields[key]) return;
          state.blurredFields[key] = 1;
          track('CodFormField', {
            field: key,
            action: 'blur',
            cod_session_id: sanitize(state.sessionId || ''),
          });
        } else {
          if (state.seenFields[key]) {
            track('CodFormField', {
              field: key,
              action: 'blur_empty',
              cod_session_id: sanitize(state.sessionId || ''),
            });
          }
        }
      },
      true
    );

    document.addEventListener(
      'click',
      function (ev) {
        var el = ev.target;
        if (!el || !el.closest) return;

        // CTA outside form
        var cta = el.closest('button, a, [role="button"]');
        if (cta && !inCod(cta)) {
          var t = (cta.textContent || '').trim();
          if (isReleasitBuyCta(el) || isCodCtaLabel(t)) {
            var ctaEl = el.closest('#rsi_buy_now_button, [data-rsi-cod-button="true"]') || cta;
            var cs = ctaEl ? window.getComputedStyle(ctaEl) : null;
            var placement = cs && cs.position === 'fixed' ? 'float' : 'atf';
            track('CodCtaClick', { label: sanitize(t.slice(0, 40)), placement: placement });
            startPoll('cta');
          }
          return;
        }

        if (!inCod(el)) return;

        var closeBtn = el.closest('.rsi-form-close-button');
        if (closeBtn) {
          // close observed via attribute
          return;
        }

        var submit = el.closest(
          '[data-rsi-cod-button="true"], button.rsi-submit_button, button.rsi-additionals_checkout_button, button[type="submit"]'
        );
        if (submit) {
          var isCard =
            submit.classList && submit.classList.contains('rsi-additionals_checkout_button');
          track('CodFormSubmitClick', {
            label: sanitize(((submit.textContent || '').trim()).slice(0, 40)),
            last_field: sanitize(state.lastField),
            cta_type: isCard ? 'card' : 'cod',
            cod_session_id: sanitize(state.sessionId || ''),
          });
        }
      },
      true
    );

    // --- MutationObservers ---
    // Objetivo: scope lo más estrecho posible. Se enganchan a #rsi_form_wrapper
    // en cuanto existe; mientras tanto solo se vigila document.body (childList).

    function handleErrorMutation(muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes || [], function (n) {
          if (!n || n.nodeType !== 1) return;
          var cls = String(n.className || '');
          if (/rsi-text-input-error|rsi-select-error|rsi-checkbox-error|rsi-form-error|rsi-error/i.test(cls)) {
            var txt = (n.textContent || '').trim();
            if (txt.length > 0) {
              noteError('releasit_ui', state.lastField);
              track('CodFormError', {
                field: sanitize(state.lastField),
                error_msg: sanitize(txt.slice(0, 80)),
                error_type: 'releasit_ui',
                source: 'releasit',
                cod_session_id: sanitize(state.sessionId || ''),
              });
            }
          }
        });
        if (m.type === 'characterData' || m.type === 'childList') {
          var row = m.target && m.target.closest && m.target.closest('.rsi-text-input-error-row, .rsi-select-error-row, .rsi-checkbox-error-row');
          var rowTxt = row ? (row.textContent || '').trim() : '';
          if (row && rowTxt) {
            noteError('releasit_ui', state.lastField);
            track('CodFormError', {
              field: sanitize(state.lastField),
              error_msg: sanitize(rowTxt.slice(0, 80)),
              error_type: 'releasit_ui',
              source: 'releasit',
              cod_session_id: sanitize(state.sessionId || ''),
            });
          }
        }
        if (m.type === 'attributes' && m.target && m.target.getAttribute && m.target.getAttribute('aria-invalid') === 'true') {
          var ariaField = fieldKey(m.target);
          var ariaMsg = m.target.getAttribute('aria-errormessage') || '';
          var ariaEl = ariaMsg ? document.getElementById(ariaMsg) : null;
          var ariaText = ariaEl ? (ariaEl.textContent || '').trim() : '';
          noteError('aria_invalid', ariaField);
          track('CodFormError', {
            field: sanitize(ariaField),
            error_msg: sanitize((ariaText || 'invalid').slice(0, 80)),
            error_type: 'aria_invalid',
            source: 'releasit',
            cod_session_id: sanitize(state.sessionId || ''),
          });
        }
      });
    }

    function handleOpenCloseMutation() {
      if (isOpen()) markOpen('mutation');
      else if (state.open) markClose();
    }

    // CodCpLookup legacy (Releasit). Con prefill Menvora (CodCpSearch/CodCpResult) no duplicar.
    function attachCpLookup(formWrapper) {
      if (formWrapper.querySelector('#menvora-cp-group, [data-menvora-cp-group], #menvora-cp-search')) {
        return;
      }
      var zipField = formWrapper.querySelector('input[name="zip"], input[name="postal_code"], input#zip, input#postal_code');
      var coloniaParent = formWrapper.querySelector('.rsi-colonia-field, [data-field="colonia"], #colonia');
      if (!zipField) return;

      var cpAttempts = {};
      zipField.addEventListener('change', function () {
        var cp = String(zipField.value || '').replace(/\D/g, '').slice(0, 5);
        if (cp.length < 4) return;
        cpAttempts[cp] = (cpAttempts[cp] || 0) + 1;
        track('CodCpLookup', { cp_len: cp.length, attempt: cpAttempts[cp], result: 'pending' });

        // Observar resultado: si colonia se puebla → ok; si queda vacío → not_found
        var coloniaEl = formWrapper.querySelector('select[name="address2"], select[name="colonia"], #address2');
        if (!coloniaEl) return;
        var resultMo = new MutationObserver(function () {
          var opts = coloniaEl.querySelectorAll('option:not([value=""])');
          var result = opts.length > 0 ? 'ok' : 'not_found';
          resultMo.disconnect();
          track('CodCpLookup', { cp_len: cp.length, attempt: cpAttempts[cp], result: result, options: opts.length });
        });
        resultMo.observe(coloniaEl, { childList: true });
        // Timeout: si en 6s no hubo respuesta, marcar timeout
        setTimeout(function () {
          resultMo.disconnect();
        }, 6000);
      });
    }

    // Enganche diferido: observar document.body (ligero) hasta que aparezca el form wrapper
    var errorMo = new MutationObserver(handleErrorMutation);
    var openCloseMo = new MutationObserver(handleOpenCloseMutation);
    var formWrapperMo = null;

    function attachNarrowObservers(wrapper) {
      errorMo.observe(wrapper, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['aria-invalid', 'aria-errormessage', 'data-page'],
      });
      openCloseMo.observe(wrapper, {
        attributes: true,
        attributeFilter: ['open', 'data-open', 'class'],
      });
      // open/close también requiere observer en el padre inmediato para childList (dialogs)
      if (wrapper.parentElement) {
        openCloseMo.observe(wrapper.parentElement, { childList: true });
      }
      attachCpLookup(wrapper);
      if (formWrapperMo) { formWrapperMo.disconnect(); formWrapperMo = null; }
    }

    var existingWrapper = dialogEl();
    if (existingWrapper) {
      attachNarrowObservers(existingWrapper);
    } else {
      // Watcher ligero en body hasta que Releasit inyecte el wrapper
      formWrapperMo = new MutationObserver(function () {
        var w = dialogEl();
        if (w) attachNarrowObservers(w);
      });
      formWrapperMo.observe(document.body, { childList: true, subtree: false });
    }

    document.addEventListener(
      'toggle',
      function (ev) {
        if (ev.target && ev.target.id === 'rsi_form_wrapper') {
          if (ev.target.open || ev.target.hasAttribute('open')) markOpen('toggle');
          else markClose();
        }
      },
      true
    );
  }

  function startPoll(reason) {
    if (state.poll) clearInterval(state.poll);
    var tries = 0;
    state.poll = setInterval(function () {
      tries += 1;
      if (isOpen()) {
        clearInterval(state.poll);
        state.poll = null;
        markOpen('poll_' + reason);
      } else if (tries > 50) {
        clearInterval(state.poll);
        state.poll = null;
      }
    }, 100);
  }

  // --- Page dwell: window load → pagehide (reloj de pared, sin pausar en tabs) ---
  var page = {
    loadedAt: null,
    sentFinal: false,
    milestones: { 15: false, 30: false, 60: false, 120: false },
  };

  function pagePath() {
    try {
      return sanitize((location.pathname || '').slice(0, 80));
    } catch (e) {
      return 'unknown';
    }
  }

  function elapsedMs() {
    if (!page.loadedAt) return 0;
    return Date.now() - page.loadedAt;
  }

  function dwellPayload(extra) {
    var p = {
      path: pagePath(),
      dwell_ms: elapsedMs(),
      form_open: state.open ? 1 : 0,
      last_field: sanitize(state.lastField),
    };
    if (extra) {
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
      }
    }
    return p;
  }

  function checkMilestones() {
    if (!page.loadedAt || page.sentFinal) return;
    var sec = Math.floor(elapsedMs() / 1000);
    var marks = [15, 30, 60, 120];
    for (var i = 0; i < marks.length; i++) {
      var m = marks[i];
      if (sec >= m && !page.milestones[m]) {
        page.milestones[m] = true;
        track('PageEngage', dwellPayload({ seconds: m }));
      }
    }
  }

  function markLoaded(reason) {
    if (page.loadedAt) return;
    page.loadedAt = Date.now();
    track('PageLoad', { path: pagePath(), reason: sanitize(reason) });
  }

  function sendPageDwell(reason) {
    if (!page.loadedAt || page.sentFinal) return;
    page.sentFinal = true;
    track('PageDwell', dwellPayload({ reason: sanitize(reason) }));
  }

  // Start: document/window load (si ya cargó, marca ya)
  if (document.readyState === 'complete') {
    markLoaded('already_complete');
  } else {
    window.addEventListener('load', function () {
      markLoaded('load');
    });
  }
  // bfcache restore
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) {
      page.sentFinal = false;
      page.milestones = { 15: false, 30: false, 60: false, 120: false };
      page.loadedAt = Date.now();
      track('PageLoad', { path: pagePath(), reason: 'pageshow_bfcache' });
    }
  });

  // End: page close / navigate away
  window.addEventListener('pagehide', function () {
    if (state.open) emitAbandon('page_hide');
    sendPageDwell('pagehide');
  });

  // Tab/app hide con form abierto → abandon (si empezó a llenar).
  // NO emitir CodFormSuccessHint: v≤3.7 lo disparaba aquí con reason
  // page_hide_while_form_open y se leía como «éxito» en GA4/analyst
  // (bebedero 2026-09: 39 hints / 0 submits / 34 opens).
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden' && state.open) {
      emitAbandon('page_hide');
    }
  });

  // Prefill / guards pueden marcar submit allowed o errores vía custom events
  window.addEventListener('menvora:cod-submit-allowed', function () {
    state.submitAllowed = true;
    syncCodSession();
  });
  window.addEventListener('menvora:cod-form-error', function (ev) {
    var d = (ev && ev.detail) || {};
    noteError(d.error_type || 'menvora', d.field || state.lastField);
  });

  setInterval(checkMilestones, 5000);

  bind();
  setTimeout(function () {
    if (isOpen()) markOpen('autoload');
  }, 500);
})();
